export const CONTACT = {
  phone: "7737832890",
  phoneDisplay: "+91 77378 32890",
  whatsapp: "917737832890",
  area: "रामगंजमंडी, कोटा (राजस्थान)",
  areaEn: "Ramganjmandi, Kota (Rajasthan)",
  address: "SS Fitness Studio, near Gordhanpura Bijasan Mataji Mandir, Ramganjmandi (326519)",
  pincode: "326519",
};

export const MAPS_EMBED =
  "https://www.google.com/maps?q=SS+Fitness+Studio+Gordhanpura+Bijasan+Mataji+Mandir+Ramganjmandi+326519&output=embed";

export const IMAGES = {
  jcbHero:
    "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/ewskriz7_IMG_20260721_172355.webp",
  tigor:
    "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/xjn9ejbi_IMG_20251020_194442.webp",
  ertiga:
    "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/gretsz8o_IMG_20251021_073528.webp",
  sandstone: "https://images.pexels.com/photos/33823953/pexels-photo-33823953.jpeg",
  roadWork:
    "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/afhqk5s8_IMG_20260721_172348.webp",
  operator:
    "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/ab8trxkz_IMG_20251021_073621.webp",
};

export const CONSTRUCTION_SERVICES = [
  { hi: "खुदाई", en: "Excavation" },
  { hi: "लेवलिंग", en: "Leveling" },
  { hi: "सड़क कार्य", en: "Road Work" },
  { hi: "प्लॉट सफाई", en: "Plot Cleaning" },
  { hi: "नींव खुदाई", en: "Foundation Digging" },
  { hi: "मलबा हटाना", en: "Debris Removal" },
];

export const TRAVEL_SERVICES = [
  { hi: "एयरपोर्ट पिकअप", en: "Airport Pickup" },
  { hi: "रेलवे स्टेशन", en: "Railway Station" },
  { hi: "शादी बुकिंग", en: "Wedding Booking" },
  { hi: "आउटस्टेशन टूर", en: "Outstation Tour" },
  { hi: "लोकल यात्रा", en: "Local Travel" },
  { hi: "फैमिली ट्रिप", en: "Family Trip" },
];

export const FLEET = [
  {
    id: "jcb",
    tag: "SS CONSTRUCTION",
    name: "JCB मशीन",
    nameEn: "JCB Backhoe Loader",
    meta: "2 यूनिट • अनुभवी ऑपरेटर",
    img: IMAGES.roadWork,
    accent: "jcb",
    span: "md:col-span-8 md:row-span-2",
  },
  {
    id: "ertiga",
    tag: "SS STUDENT TRAVELS",
    name: "Maruti Ertiga",
    nameEn: "Taxi Permit • 7 Seater",
    meta: "परिवार व आउटस्टेशन यात्रा",
    img: IMAGES.ertiga,
    accent: "terra",
    span: "md:col-span-4 md:row-span-1",
  },
  {
    id: "tigor",
    tag: "SS STUDENT TRAVELS",
    name: "Tata Tigor",
    nameEn: "Sedan • Local & Outstation",
    meta: "लोकल और आउटस्टेशन बुकिंग",
    img: IMAGES.tigor,
    accent: "terra",
    span: "md:col-span-4 md:row-span-1",
  },
];

export const GALLERY = [
  {
    id: "wedding",
    img: "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/d5qira0a_file_00000000f9a4820b9c3ad20099323e6a.png",
    hi: "शादी बुकिंग",
    en: "Wedding Rides",
    span: "md:col-span-5 md:row-span-2",
  },
  {
    id: "kashmir",
    img: "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/niz8bbj7_IMG_20260726_133321.jpg",
    hi: "कश्मीर टूर",
    en: "Kashmir Tour",
    span: "md:col-span-7 md:row-span-1",
  },
  {
    id: "group",
    img: "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/2064iwmo_IMG_20260726_133332.webp",
    hi: "आउटस्टेशन यात्रा",
    en: "Outstation Ride",
    pos: "object-top",
    span: "md:col-span-7 md:row-span-1",
  },
  {
    id: "snow",
    img: "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/pg4iym44_IMG_20260726_133345.jpg",
    hi: "ग्रुप टूर",
    en: "Group Tour",
    span: "md:col-span-6 md:row-span-1",
  },
  {
    id: "celebration",
    img: "https://customer-assets-v7afamib.emergentagent.net/job_ss-heavy-taxi/artifacts/lrbl5p2m_IMG_20260726_133308.webp",
    hi: "खुशियों का सफर",
    en: "Happy Celebrations",
    span: "md:col-span-6 md:row-span-1",
  },
];

export const BOOKING_OPTIONS = [
  "JCB — खुदाई / Excavation",
  "JCB — लेवलिंग / Leveling",
  "JCB — सड़क कार्य / Road Work",
  "JCB — प्लॉट सफाई / Plot Cleaning",
  "Taxi — Maruti Ertiga",
  "Taxi — Tata Tigor",
  "Taxi — एयरपोर्ट / Airport",
  "Taxi — शादी / Wedding",
  "अन्य / Other",
];
